import moment from "moment-timezone";
// O moment-timezone usa uma instância própria do moment (aninhada em
// node_modules/moment-timezone/node_modules/moment), separada da instância top-level
// configurada no App.js. O bundler não inclui o carregamento sob demanda do locale, então
// registramos o pt-br explicitamente nessa instância aninhada.
import "moment-timezone/node_modules/moment/locale/pt-br";

// Forçamos pt-br aqui para que os valores gerados (ex.: usados no antd DatePicker)
// renderizem o calendário em português, espelhando o que o App.js faz no moment puro.
moment.locale("pt-br");

/**
 * Converts a date to the start of the day in the "America/Sao_Paulo" timezone.
 * @param {Date} date - The date to convert.
 *
 * @returns {moment.Moment} - The date at the start of the day in the specified timezone.
 * @throws {Error} - Throws an error if the date is invalid.
 *
 * @example
 * // const date = new Date('2023-10-01T12:00:00Z');
 * // const startOfDay = momentTimeZoneZeroHour(date);
 * // console.log(startOfDay.format()); // Outputs the date at 00:00:00 in America/Sao_Paulo timezone
 * */
const momentTimeZoneZeroHour = (date) =>
  moment(
    moment(date)
      .tz("America/Sao_Paulo")
      .startOf("day")
      .format(moment.HTML5_FMT.DATE)
  ).locale("pt-br");

/**
 * Retorna o horário correspondente à data fornecida (em UTC) no timezone "America/Sao_Paulo".
 * @param {Date|string|number} date - Data em UTC que será convertida.
 * @returns {moment.Moment} - Instância moment ajustada para o fuso horário de SP.
 *
 * @example
 * // const horaSP = momentTimeZoneHour(new Date());
 * // console.log(horaSP.format('HH:mm:ss')); // Ex: "14:03:25" (hora em SP)
 */
const momentTimeZoneHour = (date) =>
  moment.utc(date).tz("America/Sao_Paulo").locale("pt-br");

export { momentTimeZoneZeroHour, momentTimeZoneHour };
